export default __webpack_public_path__ + "static/media/sudoku.f258648c.png";